import cookies from "react-cookies";
import { call, delay, put, select } from "redux-saga/effects";
import { homeUrl } from "../../shared/utils/apiEndPoints";
import * as actionTypes from "../actions/actionTypes";
import * as Variable from "../../shared/utils/variables";
import { generateRequestOptions } from "../../shared/utils/apiEndPoints";
import makeRequest from "../../shared/utils/request";
import { toast } from "react-toastify";
import { formatString } from "../../shared/utils/string";

export function* loginSucceed(action) {
	yield put({ type: actionTypes.LOGIN_SUCCEED_REDUX, payload: action.payload });
}
export function* logout() {
	const state = yield select();
	if (cookies.load("psrefreshtoken")) {
		let res = yield makeRequest({
			...generateRequestOptions("logout"),
			headers: {
				Accept: "application/json",
				"content-type": "application/json",
			},
			body: {
				revoke_token: false,
				refresh_token: cookies.load("psrefreshtoken"),
			},
			json: true,
		});
		if (res?.code === 200) {
			yield call(
				toast.success,
				Variable.LOGGED_OUT[state.auth.selectedEnvironment || "bhs"]
			);
		}
	}

	cookies.remove("psauthtoken", { path: "/", domain: homeUrl });
	cookies.remove("psrefreshtoken", { path: "/", domain: homeUrl });

	yield put({
		type: actionTypes.LOGOUT_SUCCEED,
	});
}
export function* fetchFavorites() {
	const state = yield select();
	let res = yield makeRequest(generateRequestOptions("favoriteCount"));
	if (res?.code === 200) {
		yield put({
			type: actionTypes.FETCH_FAVORITES_SUCCESS,
			payload: res.data?.total_favorite_item,
		});
	} else {
		yield put({ type: actionTypes.FETCH_FAVORITES_FAILED });
		// If failed, retry until 3 times
		if (state.auth.fav_retries <= 3) {
			yield delay(750);
			yield put({ type: actionTypes.FETCH_FAVORITES });
		} else {
			yield put({ type: actionTypes.FETCH_FAVORITES_FAILED_MAX_RETRIES });
		}
	}
}

/*
	payload: 
	{
		type: ActionTypes.ADD_REMOVE_FAVORITE,
		data: { 
			action: "add" or "remove"
			type: "college", "major", "career", or "scholarship" 
			id: item id if "add", favorite id if "remove"
		},
		onSuccess: function to call on success
		onFail: function to call on fail
	}
*/
export function* addRemoveFavorite(payload) {
	const state = yield select();
	if (state.fetchingAddRemoveFavorites) return;
	const ITEM_MAPPING = {
		college:
			Variable.COLLEGE[state.auth.selectedEnvironment || "bhs"].toLowerCase(),
		major:
			Variable.MAJOR[state.auth.selectedEnvironment || "bhs"].toLowerCase(),
		career:
			Variable.CAREER[state.auth.selectedEnvironment || "bhs"].toLowerCase(),
		scholarship:
			Variable.SCHOLARSHIP[
				state.auth.selectedEnvironment || "bhs"
			].toLowerCase(),
	};
	if (!payload.data?.id || !payload.data?.type) {
		yield call(
			toast.error,
			Variable.CANNOT_GET_DATA[state.auth.selectedEnvironment || "bhs"]
		);
		return;
	}
	let url, data;
	if (payload?.data?.action === "remove") {
		url = generateRequestOptions("removeFavorite", {
			urlParams: payload?.data?.id + "/",
		});
	} else {
		url = generateRequestOptions("createFavorite");
		data = {
			[payload.data.type]: payload.data?.id,
		};
	}
	let res = yield makeRequest({ ...url, ...(data ? { body: data } : {}) });
	if (res?.code === 200) {
		// On success call fetch favorite
		if (payload?.data?.action === "remove") {
			yield call(
				toast.success,
				formatString(
					Variable.SUCCESS_REMOVE_FAVORITES[
						state.auth.selectedEnvironment || "bhs"
					],
					ITEM_MAPPING?.[payload.data.type]
				)
			);
		} else {
			yield call(
				toast.success,
				formatString(
					Variable.SUCCESS_ADD_FAVORITES[
						state.auth.selectedEnvironment || "bhs"
					],
					ITEM_MAPPING?.[payload.data.type]
				)
			);
		}
		if (payload.onSuccess) yield call(payload.onSuccess, res);
		yield put({ type: actionTypes.COMPLETE_ADD_REMOVE_FAVORITE });
		yield put({ type: actionTypes.FETCH_FAVORITES });
	} else {
		if (payload?.data?.action === "remove") {
			yield call(
				toast.error,
				formatString(
					Variable.FAILED_REMOVE_FAVORITES[
						state.auth.selectedEnvironment || "bhs"
					],
					ITEM_MAPPING?.[payload.data.type]
				)
			);
		} else {
			yield call(
				toast.error,
				formatString(
					Variable.FAILED_ADD_FAVORITES[
						state.auth.selectedEnvironment || "bhs"
					],
					ITEM_MAPPING?.[payload.data.type]
				)
			);
		}
		yield put({ type: actionTypes.COMPLETE_ADD_REMOVE_FAVORITE });
		if (payload.onFail) yield call(payload.onFail, res);
	}
}
